import React from 'react'

import { Button, Modal } from '_zari/core'

import * as Sections from './sections'

const SECTIONS_IDS = {
  VENTAS: 'VEN',
  DETALLES: 'DET'
}

const HistorialVentasModal = ({ handleClose, show, idSocio }) => {
  const [activeSections, setActiveSection] = React.useState(SECTIONS_IDS.VENTAS)

  const idFacturacionRef = React.useRef()
  const anioFacturacionRef = React.useRef()

  const mostrarDetallesSection = React.useCallback(() => {
    setActiveSection(SECTIONS_IDS.DETALLES)
  }, [])

  const mostrarVentasSection = React.useCallback(() => {
    setActiveSection(SECTIONS_IDS.VENTAS)
  }, [])

  return (
    <Modal show={show} size='lg'>
      <Modal.Header>
        <Modal.Title>HISTORIAL VENTAS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {activeSections === SECTIONS_IDS.VENTAS && (
          <Sections.ListaVentasSection
            idFacturacionRef={idFacturacionRef}
            anioFacturacionRef={anioFacturacionRef}
            mostrarDetallesSection={mostrarDetallesSection}
            idSocio={idSocio}
          />
        )}
        {activeSections === SECTIONS_IDS.DETALLES && (
          <Sections.DetalleVentasSection
            idFacturacion={idFacturacionRef.current}
            anio={anioFacturacionRef.current}
            mostrarVentasSection={mostrarVentasSection}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button outline color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(HistorialVentasModal)
